
export default {
  getPortalType(state) {
    return state.type;
  },
  getPortalObject(state) {
    return state;
  },
}
